export function normalizeBase64Payload(raw: string): string | null {
  const t = raw.trim();
  if (!t) {
    return null;
  }
  try {
    atob(t);
    return t;
  } catch {
    try {
      const u = t.replace(/-/g, '+').replace(/_/g, '/');
      atob(u);
      return u;
    } catch {
      return null;
    }
  }
}

// Turns a stored signature payload into an image data URL so it can be rendered
// with <img> instead of injected into the DOM as raw markup (avoids SVG-borne XSS).
export function signatureBase64ToDataUrl(signatureBase64: string): string | null {
  const raw = signatureBase64.trim();
  if (!raw) {
    return null;
  }
  if (raw.startsWith('data:image')) {
    return raw;
  }
  const b64 = normalizeBase64Payload(raw);
  if (!b64) {
    return null;
  }
  let decoded: string;
  try {
    decoded = atob(b64);
  } catch {
    return null;
  }
  const trimmed = decoded.trimStart();
  if (trimmed.startsWith('<svg')) {
    return `data:image/svg+xml;base64,${b64}`;
  }
  // PNG signature bytes
  if (decoded.length >= 4 && decoded.charCodeAt(0) === 0x89 && decoded.slice(1, 4) === 'PNG') {
    return `data:image/png;base64,${b64}`;
  }
  return `data:image/svg+xml;base64,${b64}`;
}
